import React from 'react';

const PriceGauge = ({ verdict = 'fair', confidence = 85 }) => {
  const verdictConfig = {
    underpriced: { label: 'Underpriced', color: '#00D4FF', bg: 'rgba(0,212,255,0.1)', position: 15 },
    fair: { label: 'Fair Value', color: '#00FF88', bg: 'rgba(0,255,136,0.1)', position: 50 },
    overpriced: { label: 'Overpriced', color: '#FF4444', bg: 'rgba(255,68,68,0.1)', position: 85 },
  };
  const config = verdictConfig?.[verdict] || verdictConfig?.fair;

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Price Assessment</h3>
      <div className="relative mb-6">
        <div className="h-4 rounded-full overflow-hidden" style={{ background: 'linear-gradient(to right, #00D4FF, #00FF88, #FFAA00, #FF4444)' }}>
          <div
            className="absolute top-0 w-4 h-4 rounded-full border-2 border-white shadow-lg transition-all duration-700"
            style={{ left: `calc(${config?.position}% - 8px)`, background: config?.color, boxShadow: `0 0 12px ${config?.color}` }}
          />
        </div>
        <div className="flex justify-between text-xs text-muted-foreground mt-2">
          <span>Underpriced</span>
          <span>Fair Value</span>
          <span>Overpriced</span>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: config?.bg, border: `2px solid ${config?.color}` }}>
            <span className="text-lg font-bold" style={{ color: config?.color }}>
              {verdict === 'underpriced' ? '↓' : verdict === 'overpriced' ? '↑' : '='}
            </span>
          </div>
          <div>
            <p className="font-semibold text-foreground">{config?.label}</p>
            <p className="text-sm text-muted-foreground">AI Verdict</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-2xl font-bold" style={{ color: config?.color }}>{confidence}%</p>
          <p className="text-xs text-muted-foreground">Confidence</p>
        </div>
      </div>
    </div>
  );
};

export default PriceGauge;
